module.exports = __webpack_public_path__ + "images/a85f987b6b03c733b1ff84a7b9709cd6.svg";